import { Carousel } from "@mantine/carousel";
import { useForeChartsQuery, useForeRecommendChartsQuery } from "services/api";
import Card from "features/forestage/_shared/Card";
import CardStatic from "features/forestage/_shared/CardStatic";
import ScrollRight from "features/forestage/_shared/Layout/ScrollRight";

import Kv from "images/kv.svg";
import KvMobile from "images/kv-mobile.svg";
import { useMediaQuery } from "@mantine/hooks";
import { useSetCategoryContext } from "./Categories/CategoryContext";
import { useEffect } from "react";
import { Helmet } from "react-helmet";

const RECOMMEND_COUNT = 6;

const Home = () => {
  const { data: recommendCharts = [] } =
    useForeRecommendChartsQuery(RECOMMEND_COUNT);

  const { data: charts = [] } = useForeChartsQuery();

  const matches = useMediaQuery("(min-width: 768px)");

  const setActivatedCategory = useSetCategoryContext();

  useEffect(() => {
    setActivatedCategory(undefined);
  }, [setActivatedCategory]);

  return (
    <>
      <Helmet>
        <title>臺南城市儀表板</title>
        <meta property="og:title" content="臺南城市儀表板" />

        <meta name="description" content="掌握城市脈動，用大數據認識臺南。" />
        <meta
          property="og:description"
          content="掌握城市脈動，用大數據認識臺南。"
        />

        <meta property="og:url" content="https://dashboard.tainan.gov.tw" />
      </Helmet>
      <div className="-mx-4 mb-4 -mt-4 md:mx-0 md:mt-0">
        <img
          width={"100%"}
          src={matches ? Kv : KvMobile}
          alt="KV"
          draggable="false"
        />
      </div>
      {recommendCharts.length > 0 && (
        <section className="mb-[68px]">
          <div className="flex items-center justify-between">
            <h2 className="mb-4 flex items-center text-[18px] md:mb-8 md:text-2xl">
              <span className="mr-4 h-8 w-3 rounded-sm bg-grandma-300 content-['']"></span>
              熱門
              <span className="font-normal">儀表板</span>
            </h2>
          </div>

          <div className="my-0 -mx-[1rem]">
            <Carousel
              loop
              align="start"
              withControls={matches}
              withIndicators
              slideGap={20}
              slideSize="33.333333%"
              breakpoints={[
                { maxWidth: "md", slideSize: "45%" },
                { maxWidth: "xs", slideSize: "102%" },
              ]}
              styles={{
                root: {
                  padding: "10px 10px 30px",
                },
                indicators: {
                  bottom: 0,
                },
                indicator: {
                  marginTop: 100,
                  width: 12,
                  height: 4,
                  transition: "width 250ms ease",
                  backgroundColor: "#C4C4C4",

                  "&[data-active]": {
                    width: 40,
                    backgroundColor: "#1FC1AE",
                  },
                },
                controls: {
                  top: "calc(50% - 56px)",
                },
                slide: {
                  // marginRight: 24
                  // flex: "0 0 calc(33.3333% - 13px)",
                },
              }}
            >
              {recommendCharts.map((item) => (
                <Carousel.Slide key={item.id}>
                  <CardStatic
                    categoryId={item.categoryId}
                    dataSource={item.dataSource || item.unitName}
                    id={item.id}
                    name={item.boardName}
                    thumbnailUrl={item.thumbnailUrl}
                    url={item.url}
                    viewsCount={item.viewsCount}
                  ></CardStatic>
                </Carousel.Slide>
              ))}
            </Carousel>
          </div>

          <div className="-mt-2 mr-2 flex justify-end md:mr-5 lg:hidden">
            <ScrollRight />
          </div>
        </section>
      )}

      {charts.length > 0 && (
        <section>
          <div className="mb-4 flex items-center justify-between md:mb-8">
            <h2 className="flex items-center text-[18px] md:text-2xl">
              <span className="mr-4 h-8 w-3 rounded-sm bg-grandma-300 content-['']"></span>
              所有
              <span className="font-normal">儀表板</span>
            </h2>
            <span className="pr-1 text-[14px] text-[#5E5E5E] md:text-base">
              共 {charts.length} 筆資料
            </span>
          </div>

          <div>
            <ul className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
              {charts.map((item) => (
                <li key={item.id}>
                  <Card
                    categoryId={item.categoryId}
                    dataSource={item.dataSource || item.unitName}
                    id={item.id}
                    name={item.boardName}
                    thumbnailUrl={item.thumbnailUrl}
                    url={item.url}
                    viewsCount={item.viewsCount}
                  ></Card>
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}
    </>
  );
};

export default Home;
